module.exports = __webpack_public_path__ + "img/虚拟币交易hash.103749cb.png";